import { useOnScroll } from './useOnScroll';

const ref =
  typeof window === 'undefined' ? { current: null } : { current: window };

export const useOnWindowScroll = (onScroll: (event: Event) => void) =>
  useOnScroll(ref, onScroll);
